var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-overlay',{attrs:{"show":_vm.showTv},on:{"click":_vm.hideTv}},[_c('div',{staticStyle:{"width":"100%","height":"auto","margin-top":"140px"},attrs:{"id":"id_test_video"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }